import React from 'react';
import './ConnectionPanel.css';

const ConnectionPanel = ({ wsUrl, setWsUrl, address, setAddress, isConnected, onConnect, onDisconnect }) => {
  return (
    <div className="connection-panel">
      <div className="status-bar">
        <span className="status-label">Stanje:</span>
        <span className={`status-badge ${isConnected ? 'connected' : 'disconnected'}`}>
          <span className="status-dot"></span>
          {isConnected ? 'POVEZANO' : 'NI POVEZAVE'}
        </span>
      </div>

      <div className="connection-form">
        <input
          type="text"
          className="url-input"
          placeholder="WebSocket URL"
          value={wsUrl}
          onChange={(e) => setWsUrl(e.target.value)}
          disabled={isConnected}
        />

        <input
          type="text"
          className="url-input address-input"
          placeholder="Naslov nepremicnine (npr. Dunajska cesta 1, Ljubljana)"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          disabled={isConnected}
        />

        <div className="button-group">
          <button
            className="btn btn-primary"
            onClick={onConnect}
            disabled={isConnected || !wsUrl || !address?.trim()}
          >
            <span className="btn-icon">??</span>
            Povezi
          </button>
          
          <button
            className="btn btn-danger"
            onClick={onDisconnect}
            disabled={!isConnected}
          >
            <span className="btn-icon">??</span>
            Prekini
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConnectionPanel;
